// extracted by mini-css-extract-plugin
module.exports = {"container":"AdsRow_container__iw1nV","close":"AdsRow_close__RSHu1","cross":"AdsRow_cross__3r9yE"};